import * as React from "react";
// import * as ReactRedux from "react-redux";
// import { navigateTo } from "gatsby-link";
// import * as Arrow from '../../res/arrow.svg';

interface DocFolderCellProps {
	title: string;
	children: any;
	// isInitiallyOpen: boolean;
}

/**
 * collapsable document folder cell for display in a page sidebar
 */
class DocFolderCellComponent extends React.Component<DocFolderCellProps, any> {
	state = {
		isOpen: true,
	};

	// componentDidMount() {
	// 	this.setState({ isOpen: this.props.isInitiallyOpen });
	// }

	toggleOpen() {
		this.setState({ isOpen: !this.state.isOpen });
	}

	render() {
		const { title, children } = this.props;
		const { isOpen } = this.state;

		return (
			<div
				style={{
					color: isOpen ? "#363636" : "#636363",
					marginBottom: 20,
				}}
			>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						color: "#363636",
						position: "relative",
						padding: "10px 10px 10px 30px"
					}}
					// onClick={this.toggleOpen.bind(this)}
				>
					<h4 style={{ 
						color: "#001226",
						fontFamily: "Inter MD",
						fontSize: "15px",
						lineHeight: "20px",
						fontWeight: "normal",
						margin: 0
					}}>{title}</h4>

					{/* <img src={Arrow} style={{
						transform: !isOpen ? "translateY(-50%) rotate(-90deg)" : "translateY(-50%) rotate(0)",
						position: "absolute",
						right: "0",
						top: "50%",
					}}/> */}
				</div>

				<div
					style={{
						display: isOpen ? "block" : "none",
					}}
				>
					{children}
				</div>
			</div>
		);
	}
}

export default DocFolderCellComponent;



// WEBPACK FOOTER //
// ./src/components/DocFolderCell/DocFolderCell.tsx